// Import the functions you need from the SDKs you need
import { getApp, getApps, initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCSS-2ZfQav2PyKxI_q2niTbLtZwP8T3JA",
  authDomain: "cinema-guide-ireland.firebaseapp.com",
  projectId: "cinema-guide-ireland",
  storageBucket: "cinema-guide-ireland.firebasestorage.app",
  messagingSenderId: "1033406035992",
  appId: "1:1033406035992:web:2fecb80db372f3e1726b6d",
  measurementId: "G-BVQCH8CVE5"
};

// Initialize Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const functions = getFunctions(app, "europe-west2");
export const analytics = getAnalytics(app);
